// frontend/src/context/CompareContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const CompareContext = createContext();

export const useCompare = () => useContext(CompareContext);

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);

  // Load from LocalStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('compareList');
    if (stored) {
      setCompareList(JSON.parse(stored));
    }
  }, []);

  // Save to LocalStorage whenever list changes
  useEffect(() => {
    localStorage.setItem('compareList', JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (vehicle) => {
    if (compareList.find(v => v.id === vehicle.id)) {
      alert("This vehicle is already in your compare list.");
      return;
    }
    if (compareList.length >= 3) {
      alert("You can only compare up to 3 vehicles at a time. Please remove one first.");
      return;
    }
    
    // Store only necessary data to save space
    const vehicleData = {
      id: vehicle.id,
      make: vehicle.make,
      model: vehicle.model,
      year: vehicle.year,
      price: vehicle.price,
      mileage: vehicle.mileage,
      transmission: vehicle.transmission,
      condition: vehicle.condition,
      image: vehicle.images?.front || Object.values(vehicle.images || {})[0],
      features: vehicle.features || []
    };

    setCompareList(prev => [...prev, vehicleData]);
  };

  const removeFromCompare = (vehicleId) => {
    setCompareList(prev => prev.filter(v => v.id !== vehicleId));
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const isInCompare = (vehicleId) => {
    return compareList.some(v => v.id === vehicleId);
  };

  const value = {
    compareList,
    addToCompare,
    removeFromCompare,
    clearCompare,
    isInCompare
  };

  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
};